import { APIService } from "../api-service";
import { getAccessToken } from "../../lib/general/token";
import {
  LeadDocument,
  DocumentUploadResponse,
  DocumentListResponse,
} from "./types";

export class LeadDocumentService extends APIService {
  static readonly DOCUMENTS_API = `${this.API_PREFIX_URL}/leads`;

  static async uploadDocuments(
    leadId: string,
    files: File[]
  ): Promise<LeadDocument[]> {
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));

    const response = await this.post<DocumentUploadResponse>(
      `${this.DOCUMENTS_API}/${leadId}/documents/upload`,
      formData,
      { withAuthToken: true, formData: true }
    );

    return response.data.item ?? [];
  }

  static async getDocuments(leadId: string): Promise<LeadDocument[]> {
    const response = await this.get<DocumentListResponse>(
      `${this.DOCUMENTS_API}/${leadId}/documents`,
      { withAuthToken: true }
    );

    return response.data.items ?? [];
  }

  static async deleteDocument(
    leadId: string,
    documentId: string
  ): Promise<void> {
    await this.delete(
      `${this.DOCUMENTS_API}/${leadId}/documents/${documentId}`,
      { withAuthToken: true }
    );
  }

  static async downloadDocument(
    leadId: string,
    documentId: string
  ): Promise<void> {
    const token = getAccessToken();
    const response = await this.APIClient.get<{
      item: { downloadUrl: string };
    }>(
      `${this.DOCUMENTS_API}/${leadId}/documents/${documentId}/download-url`,
      { headers: token ? { Authorization: token } : {} },
    );
    window.open(response.data.item.downloadUrl, "_blank", "noopener,noreferrer");
  }
}

export type { LeadDocument, DocumentUploadResponse, DocumentListResponse };
